import superagent from 'superagent'

export default async function (appStrId, year, month) {
  const resp = await superagent.get(`/api/stat/${appStrId}/${year}/${month}`);
  return resp.body;
}